/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const SvgSearch = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={17}
    viewBox='0 0 16 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    role='img'
    {...props}
  >
    <g clipPath='url(#clip0)'>
      <path
        d='M8.53101 11.6827C11.0778 10.6003 12.265 7.65829 11.1826 5.11148C10.1002 2.56467 7.15822 1.37751 4.61141 2.45988C2.0646 3.54224 0.877433 6.48428 1.9598 9.03109C3.04217 11.5779 5.9842 12.7651 8.53101 11.6827Z'
        stroke='currentColor'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
      <path
        d='M10.1143 10.614L14.0003 14.5006'
        stroke='currentColor'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0'>
        <rect width={16} height={16} fill='white' transform='translate(0 0.5)' />
      </clipPath>
    </defs>
  </svg>
)
export default SvgSearch
